import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalOverlayFn = /* @__PURE__ */ createRecipe('modalOverlay', {}, [])

const modalOverlayVariantMap = {}

const modalOverlayVariantKeys = Object.keys(modalOverlayVariantMap)

export const modalOverlay = /* @__PURE__ */ Object.assign(memo(modalOverlayFn), {
  __recipe__: true,
  __name__: 'modalOverlay',
  raw: (props) => props,
  variantKeys: modalOverlayVariantKeys,
  variantMap: modalOverlayVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalOverlayVariantKeys)
  },
})